import React, { useEffect, useState } from "react";
import { Rocket, Smartphone, Bot, Wallet, Video } from "lucide-react";
import "./coach-landing.css";
import { trackCoachFormSubmit } from "../../analytics/googleAnalytics";

// Los iconos de la lista de ventajas no deben encogerse ni bajar con el texto
const ventajaIconStyle = { marginRight: "10px", flexShrink: 0, marginTop: "2px" };

export default function WaitlistCoach() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const apiUrl =
    window.location.hostname === "localhost"
      ? "http://127.0.0.1:8000/api/waitlist"
      : "https://api.wayoai.app/api/waitlist";

  useEffect(() => {
    const dismissed = sessionStorage.getItem("coachWaitlistDismissed");
    if (dismissed) return;

    // Sale al bajar media pagina, no a los 5 s de entrar: Google penaliza en
    // movil los popups que tapan la pagina nada mas llegar desde el buscador, y
    // quien ya ha leido media landing esta mas dispuesto a dejar el correo.
    const onScroll = () => {
      const recorrido = document.documentElement.scrollHeight - window.innerHeight;
      if (recorrido > 0 && window.scrollY / recorrido >= 0.5) {
        setShowPopup(true);
        window.removeEventListener("scroll", onScroll);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
    sessionStorage.setItem("coachWaitlistDismissed", "1");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          fuente: "coach_landing",
        }),
      });

      if (response.ok) {
        trackCoachFormSubmit("coach_waitlist_popup");
        setSubmitted(true);
        setEmail("");

        setTimeout(() => {
          setSubmitted(false);
          closePopup();
        }, 3500);
      } else {
        const data = await response.json();
        setError(data.message || "Error al registrar el email");
      }
    } catch (err) {
      console.error("Error:", err);
      setError("Error de conexion. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  if (!showPopup) return null;

  return (
    <div
      className="waitlist-popup-overlay"
      onClick={closePopup}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(2, 6, 23, 0.72)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        className="waitlist-popup"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "white",
          borderRadius: "20px",
          maxWidth: "540px",
          width: "100%",
          maxHeight: "90vh",
          overflow: "auto",
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.35)",
          position: "relative",
        }}
      >
        <button
          onClick={closePopup}
          style={{
            position: "absolute",
            top: "14px",
            right: "14px",
            background: "none",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            color: "#64748b",
            zIndex: 1,
          }}
        >
          x
        </button>

        <div style={{ padding: "30px" }}>
          <span
            className="waitlist-badge"
            style={{
              background: "linear-gradient(135deg, #6C3AFF 0%, #764ba2 100%)",
              color: "white",
              padding: "7px 13px",
              borderRadius: "999px",
              fontSize: "12px",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              marginBottom: "20px",
            }}
          >
            <Rocket size={14} strokeWidth={2.5} aria-hidden="true" />
            EXCLUSIVO PROFESIONALES
          </span>

          <div className="waitlist-content">
            <h2
              style={{
                fontSize: "30px",
                fontWeight: "800",
                marginBottom: "15px",
                color: "#111827",
                textAlign: "center",
                lineHeight: 1.1,
              }}
            >
              Deja de perseguir clientes por WhatsApp
            </h2>
            <p
              style={{
                color: "#64748b",
                fontSize: "16px",
                lineHeight: "1.65",
                marginBottom: "24px",
                textAlign: "center",
              }}
            >
              Digitaliza tu asesoría con la tecnología de Wayo. Gestión de clientes, planes de entreno y análisis de comidas con IA. Todo gratis.
            </p>

            <div
              style={{
                background: "linear-gradient(135deg, #6C3AFF 0%, #764ba2 100%)",
                borderRadius: "16px",
                padding: "22px",
                margin: "20px 0",
                boxShadow: "0 12px 28px rgba(108, 58, 255, 0.2)",
              }}
            >
              <h3
                style={{
                  color: "white",
                  marginBottom: "15px",
                  fontSize: "18px",
                  textAlign: "center",
                }}
              >
                Ventajas Wayo Pro
              </h3>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start", color: "white" }}>
                  <Smartphone size={18} strokeWidth={2} aria-hidden="true" style={ventajaIconStyle} />
                  <span><b>Gestión centralizada:</b> adiós al caos de Excel, Drive y chats infinitos.</span>
                </li>
                <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start", color: "white" }}>
                  <Bot size={18} strokeWidth={2} aria-hidden="true" style={ventajaIconStyle} />
                  <span><b>IA nutricional:</b> el plan de comidas en segundos, y tus clientes registran lo que comen con una foto.</span>
                </li>
                <li style={{ marginBottom: "10px", display: "flex", alignItems: "flex-start", color: "white" }}>
                  <Wallet size={18} strokeWidth={2} aria-hidden="true" style={ventajaIconStyle} />
                  <span><b>Sin cuota:</b> gratis y sin límite de clientes, y Wayo no se queda nada de lo que cobras.</span>
                </li>
                <li style={{ display: "flex", alignItems: "flex-start", color: "white" }}>
                  <Video size={18} strokeWidth={2} aria-hidden="true" style={ventajaIconStyle} />
                  <span><b>Librería de vídeos:</b> sube tus propios entrenos y dales tu sello profesional.</span>
                </li>
              </ul>
            </div>

            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="tuemail@coach.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={submitted || loading}
                style={{
                  width: "100%",
                  padding: "13px 16px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "10px",
                  fontSize: "16px",
                  outline: "none",
                  marginBottom: "10px",
                }}
              />
              <button
                type="submit"
                disabled={submitted || loading}
                style={{
                  width: "100%",
                  background: "linear-gradient(135deg, #6C3AFF 0%, #764ba2 100%)",
                  color: "white",
                  border: "none",
                  padding: "13px 24px",
                  borderRadius: "10px",
                  fontSize: "16px",
                  fontWeight: "800",
                  cursor: "pointer",
                }}
              >
                {loading ? "..." : submitted ? "✓" : "Crear mi cuenta de Coach GRATIS"}
              </button>

              <p
                style={{
                  fontSize: "12px",
                  color: "#64748b",
                  textAlign: "center",
                  marginTop: "12px",
                }}
              >
                Sin tarjeta, sin permanencia y sin límite de clientes.
              </p>

              {error && (
                <div style={{ color: "#ef4444", marginTop: "8px", fontSize: "14px", textAlign: "center" }}>
                  {error}
                </div>
              )}
            </form>

            {submitted && (
              <div
                style={{
                  background: "#ecfdf5",
                  color: "#065f46",
                  padding: "12px",
                  borderRadius: "10px",
                  textAlign: "center",
                  marginTop: "15px",
                  border: "1px solid #a7f3d0",
                }}
              >
                ✓ Perfecto. Te contactaremos con tu acceso profesional.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
